import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from '@atlassian/jira-customer-service-support-website-pages/src/ui/__generated__/SupportWebsitePagesQuery$parameters';

export const HelpCenterSettingsSupportWebsitePagesAppEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() =>
			import(
				/* webpackChunkName: "async-help-center-setting-support-website-pages-app" */ './src/ui'
			),
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => ({
		queries: {
			customPagesQuery: {
				parameters,
				variables: {
					cloudId,
					helpCenterARI: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
					NUMBER_OF_PAGES_INITIAL_FETCH: 300,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
	}),
});
